<input
  class="form-control"
  type="date"
  [formControl]="control"
  [attr.min]="min"
  [attr.max]="max"
  (change)="change()"
  [placeholder]="placeholder"
  [pattern]="pattern"
/>
<cx-form-errors
  aria-live="assertive"
  aria-atomic="true"
  [control]="control"
  prefix="formErrors.date"
  [translationParams]="{
    max: getDate(max) | cxDate,
    min: getDate(min) | cxDate
  }"
></cx-form-errors>
